export default __webpack_public_path__ + "static/media/bigcollegebros.49dbec0c.png";